<script setup lang="ts">
const { getFormattedPrice, currencyCode } = usePrice();
const props = defineProps<{
  value: number | undefined;
}>();

// const getPrice = computed<string>(() => getFormattedPrice(props.value));

const getPrice = computed<string>(() => {
  
  const formattedPrice = new Intl.NumberFormat("de-CH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(props.value || 0);

  return `${currencyCode.value} ${formattedPrice}`;
});
</script>

<template>
  <span>
    <slot name="beforePrice" />
    {{ getPrice }}
    <slot name="afterPrice" />
  </span>
</template>
